
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const app = namespace("app");
const user = namespace("user");
@Component({})
export default class SideNav extends Vue {
  @app.State sideNavIndex;
  @app.Mutation setSideNavIndex;
  @user.State menuList;
  showHoverNav: boolean = false;
  hoverIndex: number = 0;
  childrenNav: any[] = [];
  created() {
    this.matchSideActive();
  }
  meunKeyIndexMap: any = {
    workbench: "MC001000",
    service: "MC002000",
    inventory: "MC003000",
    finance: "MC005000",
    setting: "MC007000",
    purchase: "MC004000",
    marketing: "MC006000",
    guidance: "MC008000",
    employee: "MC009000",
    study: "MC00A000",
    customer: "MC007009",
    statement: "MC00B000"
  };
  linkIndex() {
    this.$router.push("/");
  }
  matchSideActive() {
    let menuKey = this.$route.meta.menuKey;
    menuKey && this.setSideNavIndex(this.meunKeyIndexMap[menuKey]);
  }
  hoverOneLevel(i, nav) {
    if (nav.children) {
      this.showHoverNav = true;
      this.hoverIndex = i;
      this.childrenNav = nav.children;
    } else {
      this.showHoverNav = false;
    }
  }
  linkNav(nav) {
    if (!nav.children) {
      this.$router.push(nav.pageUrl);
    } else {
      const path = nav.children?.[0].pageUrl || nav.children?.[0].children?.[0].pageUrl;
      if (path) {
        this.$router.push(path);
      }
    }
  }
  handleSelectMenu(index) {
    this.showHoverNav = false;
    this.$router.push(index);
  }
  @Watch("$route.path")
  watchRoute() {
    this.matchSideActive();
  }
  hideTowNavTime: any = 0;
  handleOneNavMouseleave() {
    this.hideTowNavTime = setTimeout(() => {
      this.showHoverNav = false;
    }, 300);
  }
  handleTwoNavMouseenter() {
    clearTimeout(this.hideTowNavTime);
  }
}
